import React from 'react';
import { motion } from 'framer-motion';
import { ChevronRight, CheckCircle2 } from 'lucide-react';
export function HeroSection() {
  return <section id="inicio" className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20" data-id="element-90">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-91">
        <img src="https://images.unsplash.com/photo-1504307651254-35680f356dfd?q=80&w=2070&auto=format&fit=crop" alt="Industrial Background" className="w-full h-full object-cover object-center" data-id="element-92" />
        <div className="absolute inset-0 bg-navy/85 mix-blend-multiply" data-id="element-93" />
        <div className="absolute inset-0 bg-gradient-to-t from-navy via-navy/60 to-transparent" data-id="element-94" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 w-full" data-id="element-95">
        <div className="max-w-4xl" data-id="element-96">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} data-id="element-97">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/10 border border-white/20 backdrop-blur-sm mb-6" data-id="element-98">
              <span className="w-2 h-2 rounded-full bg-jml-orange animate-pulse" data-id="element-99" />
              <span className="text-xs font-semibold tracking-wider text-gray-200 uppercase" data-id="element-100">
                Ingeniería y Mantención Industrial
              </span>
            </div>
          </motion.div>

          <motion.h1 initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2,
          ease: 'easeOut'
        }} className="text-5xl md:text-7xl font-bold text-white leading-tight mb-4 font-heading" data-id="element-101">
            JML Ingeniería y <br data-id="element-102" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-jml-blue to-blue-400" data-id="element-103">
              Mantención Industrial
            </span>
          </motion.h1>

          <motion.h2 initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.3,
          ease: 'easeOut'
        }} className="text-2xl md:text-3xl text-gray-200 font-medium mb-6 font-heading" data-id="element-104">
            Soluciones en construcción y mantenimiento para empresas que no
            pueden permitirse errores
          </motion.h2>

          <motion.p initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.4,
          ease: 'easeOut'
        }} className="text-lg md:text-xl text-gray-400 font-light mb-8 max-w-3xl" data-id="element-105">
            Más de 500 trabajos ejecutados en 5 años, incluyendo proyectos para
            Coca-Cola, Ariztía, Panaderías San Camilo, Licitaciones Públicas,
            entre otros.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.5,
          ease: 'easeOut'
        }} className="flex flex-col sm:flex-row flex-wrap gap-4 mb-10" data-id="element-106">
            <div className="flex items-center gap-2 bg-navy-light/50 border border-white/10 px-4 py-2 rounded-lg backdrop-blur-sm" data-id="element-107">
              <CheckCircle2 className="text-jml-orange" size={20} data-id="element-108" />
              <span className="text-sm font-medium text-gray-200" data-id="element-109">
                +$1.000.000.000 CLP facturados
              </span>
            </div>
            <div className="flex items-center gap-2 bg-navy-light/50 border border-white/10 px-4 py-2 rounded-lg backdrop-blur-sm" data-id="element-110">
              <CheckCircle2 className="text-jml-orange" size={20} data-id="element-111" />
              <span className="text-sm font-medium text-gray-200" data-id="element-112">
                +$200.000.000 CLP en proyectos ejecutados
              </span>
            </div>
            <div className="flex items-center gap-2 bg-navy-light/50 border border-white/10 px-4 py-2 rounded-lg backdrop-blur-sm" data-id="element-113">
              <CheckCircle2 className="text-jml-orange" size={20} data-id="element-114" />
              <span className="text-sm font-medium text-gray-200" data-id="element-115">
                0 accidentes en 5 años
              </span>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}